import { CivilStatus, CivilStatusLabel } from '@idc-forms/types/civil-status'

export { CivilStatus, CivilStatusLabel }

// FE-only: array para <select>
export const CATALOG_CIVIL_STATUS = [
  { value: CivilStatus.SINGLE, label: CivilStatusLabel[CivilStatus.SINGLE] },
  { value: CivilStatus.MARRIED, label: CivilStatusLabel[CivilStatus.MARRIED] }
]

// Aliases temporales — borrar cuando se actualicen los consumers
export const EnumCivilStatus = CivilStatus
export type EnumCivilStatus = CivilStatus
export const TYPE_CIVIL_STATUS = CivilStatus
export const NAME_CIVIL_STATUS = CivilStatusLabel
export type TypesCivilStatus = CivilStatus
